import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AuthService } from './core/services/auth.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { JwtInterceptor, ErrorInterceptor } from './core/interceptors';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MatDialogModule } from '@angular/material/dialog';
import { ApiDelayInterceptor } from './core/interceptors/api-delay.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClaimLetterComponent } from './pages/claim-letter/claim-letter.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    ClaimLetterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule,
    MatSnackBarModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule  
  ],
  providers: [AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-IN' },
    { provide: HTTP_INTERCEPTORS,useClass: ApiDelayInterceptor,multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule {
 }
